/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompleteTransferDto } from '../models/CompleteTransferDto';
import type { CreateInventoryTransferDto } from '../models/CreateInventoryTransferDto';
import type { UpdateInventoryTransferDto } from '../models/UpdateInventoryTransferDto';
import type { UpdateRequireCountingDto } from '../models/UpdateRequireCountingDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InventoryTransfersService {
    /**
     * Create a new inventory transfer
     * Creates a new inventory transfer with an auto-generated transfer code (TR-YYYY-XXX format)
     * @param requestBody
     * @returns any Transfer created successfully with auto-generated code
     * @throws ApiError
     */
    public static inventoryTransfersControllerCreate(
        requestBody: CreateInventoryTransferDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/inventory-transfers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input data`,
                401: `Unauthorized`,
                403: `Forbidden or access denied for transfer source location`,
                404: `Referenced entity not found`,
            },
        });
    }
    /**
     * Get all inventory transfers
     * @param page Page number for pagination
     * @param limit Items per page
     * @param transferCode Filter by transfer code
     * @param status Filter by transfer status
     * @param destinationLocationId Filter by destination location ID
     * @param sourceLocationId Filter by source location ID
     * @param dateFrom Filter transfers created from this date (ISO format)
     * @param dateTo Filter transfers created to this date (ISO format)
     * @param createdById Filter by user who created the transfer
     * @returns any List of inventory transfers
     * @throws ApiError
     */
    public static inventoryTransfersControllerFindAll(
        page: number = 1,
        limit: number = 10,
        transferCode?: string,
        status?: 'PENDING' | 'COMPLETED' | 'CANCELLED',
        destinationLocationId?: number,
        sourceLocationId?: number,
        dateFrom?: string,
        dateTo?: string,
        createdById?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/inventory-transfers',
            query: {
                'page': page,
                'limit': limit,
                'transferCode': transferCode,
                'status': status,
                'destinationLocationId': destinationLocationId,
                'sourceLocationId': sourceLocationId,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'createdById': createdById,
            },
        });
    }
    /**
     * Export all inventory transfers matching the applied filters to CSV
     * @param page Page number for pagination
     * @param limit Items per page
     * @param transferCode Filter by transfer code
     * @param status Filter by transfer status
     * @param destinationLocationId Filter by destination location ID
     * @param sourceLocationId Filter by source location ID
     * @param dateFrom Filter transfers created from this date (ISO format)
     * @param dateTo Filter transfers created to this date (ISO format)
     * @param createdById Filter by user who created the transfer
     * @returns any CSV file
     * @throws ApiError
     */
    public static inventoryTransfersControllerExportToCsv(
        page: number = 1,
        limit: number = 10,
        transferCode?: string,
        status?: 'PENDING' | 'COMPLETED' | 'CANCELLED',
        destinationLocationId?: number,
        sourceLocationId?: number,
        dateFrom?: string,
        dateTo?: string,
        createdById?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/inventory-transfers/export/csv',
            query: {
                'page': page,
                'limit': limit,
                'transferCode': transferCode,
                'status': status,
                'destinationLocationId': destinationLocationId,
                'sourceLocationId': sourceLocationId,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'createdById': createdById,
            },
            errors: {
                400: `Too many matching rows to export`,
            },
        });
    }
    /**
     * Get all products currently in transit status
     * @param locationId Filter by warehouse location ID
     * @returns any List of products in transit
     * @throws ApiError
     */
    public static inventoryTransfersControllerFindProductsInTransfer(
        locationId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/inventory-transfers/products-in-transfer',
            query: {
                'locationId': locationId,
            },
        });
    }
    /**
     * Get inventory transfers status summary metrics
     * @param locationId Optional location filter by source or destination
     * @returns any
     * @throws ApiError
     */
    public static inventoryTransfersControllerGetTransferSummary(
        locationId?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/inventory-transfers/metrics/summary',
            query: {
                'locationId': locationId,
            },
        });
    }
    /**
     * Get an inventory transfer by ID
     * @param id
     * @returns any Inventory transfer found
     * @throws ApiError
     */
    public static inventoryTransfersControllerFindOne(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/inventory-transfers/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Inventory transfer not found`,
            },
        });
    }
    /**
     * Update an inventory transfer
     * @param id
     * @param requestBody
     * @returns any Transfer updated successfully
     * @throws ApiError
     */
    public static inventoryTransfersControllerUpdate(
        id: string,
        requestBody: UpdateInventoryTransferDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/inventory-transfers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input data`,
                404: `Transfer not found`,
            },
        });
    }
    /**
     * Delete an inventory transfer
     * @param id
     * @returns any Transfer deleted successfully
     * @throws ApiError
     */
    public static inventoryTransfersControllerRemove(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/inventory-transfers/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Transfer cannot be deleted`,
                404: `Transfer not found`,
            },
        });
    }
    /**
     * Get transfer items for a specific transfer
     * @param id
     * @returns any List of transfer items
     * @throws ApiError
     */
    public static inventoryTransfersControllerFindTransferItems(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/inventory-transfers/{id}/items',
            path: {
                'id': id,
            },
            errors: {
                404: `Transfer not found`,
            },
        });
    }
    /**
     * Get warehouse inventory product detail in transfer context (same payload as warehouse GET by id)
     * Requires transfer permissions only. Verifies the product belongs to the transfer.
     * @param id Transfer ID
     * @param wipId Warehouse inventory product ID
     * @returns any Warehouse inventory product found
     * @throws ApiError
     */
    public static inventoryTransfersControllerFindWarehouseInventoryProductForTransfer(
        id: number,
        wipId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/inventory-transfers/{id}/warehouse-inventory-products/{wipId}',
            path: {
                'id': id,
                'wipId': wipId,
            },
            errors: {
                404: `Transfer or product not found, or product not in transfer`,
            },
        });
    }
    /**
     * Complete an inventory transfer
     * @param id
     * @param requestBody
     * @returns any Transfer completed successfully
     * @throws ApiError
     */
    public static inventoryTransfersControllerCompleteTransfer(
        id: string,
        requestBody: CompleteTransferDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/inventory-transfers/{id}/complete',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Transfer cannot be completed`,
                404: `Transfer not found`,
            },
        });
    }
    /**
     * Cancel an inventory transfer
     * @param id
     * @returns any Transfer cancelled successfully
     * @throws ApiError
     */
    public static inventoryTransfersControllerCancelTransfer(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/inventory-transfers/{id}/cancel',
            path: {
                'id': id,
            },
            errors: {
                400: `Transfer cannot be cancelled`,
                404: `Transfer not found`,
            },
        });
    }
    /**
     * Update counting requirement flag for a transfer
     * @param id Transfer ID
     * @param requestBody Counting requirement flag
     * @returns any Counting requirement flag updated successfully
     * @throws ApiError
     */
    public static inventoryTransfersControllerUpdateRequireCounting(
        id: number,
        requestBody: UpdateRequireCountingDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/inventory-transfers/{id}/require-counting',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Transfer not found`,
            },
        });
    }
}
